export default __webpack_public_path__ + "static/media/karan-image.9d6bf251.svg";